import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  processing: false,
  error: '',
  faq: {},
}

const faqSlice = createSlice({
  name: 'faq',
  initialState: initialState,
  reducers: {
    tryGetFaqById: (state, action) => { },
    tryUpdateFaq: (state, action) => { },
    tryAddFaq: (state, action) => {},
    tryCreateFaq: (state, action) => {},
    tryRemoveFaq: (state, action) => {},
    setFaq: (state, action) => {
      const { data, error } = action.payload
      if (error) {
        state.error = error
      } else {
        state.faq = data;
        state.loading = false;
      }
    },
    setUpdateFaq: (state, action) => {
      state.faq = {
        ...state.faq,
        faq: state.faq.faq.map((f) =>
          f.id === action.payload.id ? action.payload : f,
        ),
      }
      state.processing = false
    },
    setProcessing: (state, action) => {
      state.processing = action.payload;
    },
    setLoading: (state, action) => {
      state.error = ''
      state.loading = true
    },
  },
})

export const { tryGetFaqById, tryUpdateFaq, setUpdateFaq, setProcessing, setLoading, setFaq , tryAddFaq, tryCreateFaq, tryRemoveFaq} =
  faqSlice.actions

export default faqSlice.reducer
